/**
 * 카카오 JS SDK 초기화 및 공유 유틸리티
 */

declare global {
  interface Window {
    Kakao?: {
      init: (key: string) => void;
      isInitialized: () => boolean;
      Share: {
        sendDefault: (params: any) => void;
      };
    };
  }
}

export function initKakao(): void {
  const key = import.meta.env.VITE_KAKAO_JS_KEY;
  if (!key) return;
  if (window.Kakao && !window.Kakao.isInitialized()) {
    window.Kakao.init(key);
  }
}

export interface KakaoShareParams {
  title: string;
  description: string;
  imageUrl?: string;
  url: string;
}

export function shareKakao({ title, description, imageUrl, url }: KakaoShareParams): void {
  if (!window.Kakao?.isInitialized()) {
    initKakao();
  }
  if (!window.Kakao?.isInitialized()) return;

  window.Kakao.Share.sendDefault({
    objectType: 'feed',
    content: {
      title,
      description,
      imageUrl: imageUrl || '',
      link: { mobileWebUrl: url, webUrl: url },
    },
    buttons: [
      { title: '청첩장 보기', link: { mobileWebUrl: url, webUrl: url } },
    ],
  });
}
